import qs from 'query-string';
import type { GroupTag, WorkspacePathValue, WorkspaceSearchFull } from '@trinity/chat';

export const project = {
  files: (data: { id: number }) => ({
    pathname: `/projects/${data.id}/files`,
    state: {
      from: currentLocation(),
    },
  }),
  quantAnalysis: (data: {
    quantAnalysisId: number;
    itemId?: number;
    slug: string;
    versionNumber?: number;
  }) => ({
    pathname: `/projects/${data.slug}/quant-analysis/${data.quantAnalysisId}${data.versionNumber ? `/${data.versionNumber}` : ''}${data.itemId ? `?analysisItemId=${data.itemId}` : ''}`,
    state: {
      from: currentLocation(),
    },
  }),
  root: (data: { slug: string }) => ({
    pathname: `/projects/${data.slug}`,
    state: {
      from: currentLocation(),
    },
  }),
  settings: (data: { projectId: number }) => ({
    pathname: `/projects/${data.projectId}/settings`,
    state: {
      from: currentLocation(),
    },
  }),
  surveyResponses: (data: { slug: string }) => {
    return {
      pathname: `/projects/${data.slug}/responses`,
      state: {
        from: currentLocation(),
      },
    };
  },
};

export const workspaces = {
  root: (data: { workspace: WorkspacePathValue }) => ({
    pathname: ['/workspaces', data.workspace, 'files'].filter(Boolean).join('/'),
    state: {
      from: currentLocation(),
    },
  }),
  brand: (data: { brandId: number }) => ({
    pathname: `/workspaces/brands/${data.brandId}`,
    state: {
      from: currentLocation(),
    },
  }),
  file: (data: { fileId: number }) => ({
    pathname: `/workspaces/files/${data.fileId}`,
    state: {
      from: currentLocation(),
    },
  }),
  folder: (data: { folderId: number }) => ({
    pathname: `/workspaces/folders/${data.folderId}`,
    state: {
      from: currentLocation(),
    },
  }),
  search: (data: GetWorkspaceSearchLocation) => ({
    pathname: `/workspaces/search`,
    search: `?${qs.stringify({
      keywords: data.keywords,
      tab: data.tab,
      tags: data.tags ? JSON.stringify(data.tags) : undefined,
    })}`,
    state: {
      from: currentLocation(),
    },
  }),
  transcript: (data: { transcriptId: number; position?: number }) => {
    const search = data.position ? `?s=${data.position}` : undefined;
    return {
      pathname: `/workspaces/transcripts/${data.transcriptId}`,
      search,
      state: {
        from: currentLocation(),
      },
    };
  },
};

export const brand = {
  root: (data: { brandId: number }) => ({
    pathname: `/workspaces/brands/${data.brandId}`,
    state: {
      from: currentLocation(),
    },
  }),
};

export const call = {
  transcript: (data: { callId: number; slug: string; position?: number }) => {
    const search = data.position ? `?s=${data.position}` : undefined;
    return {
      pathname: `/projects/${data.slug}/calls/${data.callId}/transcript`,
      search,
      state: {
        from: currentLocation(),
      },
    };
  },
};

export function currentLocation() {
  return `${window.location.pathname}${window.location.search}`;
}


type GetWorkspaceSearchLocation = {
  tab?: WorkspaceSearchFull.SearchTab;
  keywords?: string[];
  tags?: GroupTag[];
};
